export const AMP_FLAGS = Object.freeze({
  OFFENSIVE: 'offensive',
  IRRELEVANT: 'irrelevant',
  UNWANTED: 'unwanted',
} as const);

export const AmpMetrics = Object.freeze({
  AUDIO_IMPRESSION: 'AUDIO_IMPRESSION',
  SKIP: 'SKIP',
  AUDIO_TILE_IMPRESSION: 'AUDIO_TILE_IMPRESSION',
  AUDIO_TILE_CLICK: 'AUDIO_TILE_CLICK',
  STATION_CREATE: 'STATION_CREATE',
} as const);

export const ArtistAudioMessageDeliveryTypes = Object.freeze({
  AFTER_TRACK: 'AFTER_TRACK',
  AFTER_OTHER_ARTIST_TRACK: 'AFTER_OTHER_ARTIST_TRACK',
} as const);

export const VoiceTrackDeliveryTypes = Object.freeze({
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  INTRO: 'INTRO',
  UNATTACHED: 'UNATTACHED',
} as const);
